//----------------------------
// load local combatant props
//----------------------------
export default function loadLocalCombatantProps(combatants) {
  console.log("------------------------------")
  console.log("IN loadLocalCombatantProps")
  //
  combatants.forEach((c) => {
    if (!Object.hasOwn(c, "dupe_processed")) {
      Object.defineProperty(c, "dupe_processed", {
        value: false,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "dupe_rank")) {
      Object.defineProperty(c, "dupe_rank", {
        value: false,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "roll_off")) {
      Object.defineProperty(c, "roll_off", {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "is_ranked")) {
      Object.defineProperty(c, "is_ranked", {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "headline_marker1")) {
      Object.defineProperty(c, "headline_marker1", {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "headline_marker2")) {
      Object.defineProperty(c, "headline_marker2", {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "headline_marker3")) {
      Object.defineProperty(c, "headline_marker3", {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "headline_marker4")) {
      Object.defineProperty(c, "headline_marker4", {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "extra")) {
      console.log("loadLocalCombatantProps: adding extra property to combatant = " + c.name)
      Object.defineProperty(c, "extra", {
        value: false,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
  });
  return combatants;
}
